/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  descricao: string;
}

export function useSolicitarAjuste() {
  const postData = async (props: Props) => {
    const SOLICITAR_AJUSTE = `${backofficeEnviroment}/common/backoffice/solicitar-ajuste/v1`;
    const { data } = await instance.post(SOLICITAR_AJUSTE, {
      idOportunidade: props.idOportunidade,
      descricao: props.descricao,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Ajuste solicitado com sucesso!");
    },
    onError: (error: any) => {
      const notifications = error?.response?.data?.notifications;
      const motivo = Array.isArray(notifications)
        ? notifications.map((item: any) => item?.message).join(", ")
        : error?.message || "Erro inesperado";

      toast.error(`Erro ao solicitar ajuste. Motivos: ${motivo}`, {
        autoClose: 10000,
      });
    },
  });

  return mutation;
}
